import { render, staticRenderFns } from "./NotificationCreate.vue?vue&type=template&id=66113289&scoped=true&"
import script from "./NotificationCreate.vue?vue&type=script&lang=js&"
export * from "./NotificationCreate.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCreate.vue?vue&type=style&index=0&id=66113289&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66113289",
  null
  
)

export default component.exports